export default __webpack_public_path__ + "static/media/errorFilledRed.e3f61b68.svg";